export async function addAddressCard(info) {
    const card = document.createElement('label');
    const id = `address-select-${info.id}`;
    card.classList.add('address-item');
    card.for = id;
    card.innerHTML = `
        <div class="custom-radio-label">
            <input type="radio"
                name="address-selector"
                id="${id}"
            >${info.address}
        </div>
    `;
    return card;
}